<template>
    <div>
        <b-form
            :description="description"
            :inline="inline"
        >
            <slot v-bind:fieldId="fieldId" v-bind:fieldLabel="fieldLabel">
                <label
                    v-if="!noLabel"
                    class="form-label mr-2"
                    :for="fieldId">
                    {{ fieldLabel }}: <slot name="extralabel"></slot>
                </label>
            </slot>

            <div :class="inline ? 'd-inline-flex' : 'd-flex'" class="align-items-end">
                <b-form-input
                    :id="fieldId"
                    :value="value"
                    @input="changeValue"
                    @change="changeValue"
                    :disabled="disabled"
                    :state="isValid"
                    :type="type"
                    :class="clazz"
                    :style="{width: bootstrapNative ? false : formWidth + 'rem'}"
                    :placeholder="placeholder"
                    :no-wheel="true"
                />

                <slot name="unit" v-if="inputUnit">
                    <span>{{ inputUnit }}</span>
                </slot>
            </div>

            <b-form-invalid-feedback :state="isValid">
                {{ invalidFeedback }}
            </b-form-invalid-feedback>
        </b-form>
    </div>
</template>

<script>
    import fieldMixin from "@/components/fields/FieldMixin";
    import {capitalizeFilter} from "@/utils/formatting";

    const TYPES = ['text', 'number',];

    export default {
        name: "InputField",
        mixins: [fieldMixin],
        props: {
            type: {
                type: String,
                default: 'text',
                validator: value => TYPES.indexOf(value) !== -1,
            },
            formWidth: {
                type: [Number, String],
                default: 5,
                validator: value => {
                    if (typeof(value) === 'string' && value !== 'auto') {
                        return !isNaN(parseInt(value));
                    }
                    return true;
                }
            },
            unit: {
                type: String,
                default: '',
            },
            showHelpAsUnit: {
                type: Boolean,
                default: false,
            },
            noCenterText: {
                type: Boolean,
                default: false,
            },
            noLabel: {
                type: Boolean,
                deafult: false,
            },
        },
        computed: {
            description() {
                if (this.showHelpAsUnit) {return '';}
                return capitalizeFilter(this.helpText);
            },
            inputUnit() {
                if (this.unit !== '') {
                    return this.unit;
                }
                if (this.showHelpAsUnit) {
                    return this.helpText;
                }
                return '';
            },
            clazz() {
                let clazz = '';
                if (!this.inline) {
                    clazz += ' d-inline-block';
                }
                if (!this.bootstrapNative) {
                    clazz += ' form-custom-class border-top-0 border-right-0 border-left-0 rounded-0 p-0 mr-2';
                    if (!this.noCenterText) {
                        clazz += ' text-center';
                    }
                }
                return clazz;
            },
        },
    };
</script>

<style scoped>

    .form-custom-class {
        height: 1.5rem;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }

    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: lightgrey;
    }
    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: lightgrey;
    }
    ::-ms-input-placeholder { /* Microsoft Edge */
        color: lightgrey;
    }

</style>